<template>
  <v-sheet class="py-16 bg-surface-light">
    <v-container>
      <TitleParagraphRow :value="value" />

      <v-row v-if="!items.length">
        <v-col>
          <v-alert color="info" type="info">
            We’re sorry, there are no items at this time. Please check back
            later.
          </v-alert>
        </v-col>
      </v-row>

      <template v-else>
        <v-item-group multiple>
          <v-item
            v-for="item in items"
            :key="item.id"
            v-slot="{ isSelected, toggle }"
          >
            <v-row dense>
              <v-col>
                <SimpleRevealCard
                  :title="item.name"
                  :value="isSelected"
                  @toggle="toggle"
                >
                  <!-- eslint-disable vue/no-v-html -->
                  <div
                    class="text-body-1"
                    v-html="item.overview_description"
                  ></div>

                  <v-btn
                    v-if="scheduleHref"
                    :append-icon="mdiArrowRight"
                    :href="
                      typeof scheduleHref === 'function'
                        ? scheduleHref(item)
                        : scheduleHref
                    "
                    class="text-none ma-2"
                    color="primary"
                    exact
                    rounded="pill"
                    size="large"
                  >
                    View Schedule</v-btn
                  >
                  <v-btn
                    v-if="learnHref"
                    :append-icon="mdiArrowRight"
                    :href="
                      typeof learnHref === 'function'
                        ? learnHref(item)
                        : learnHref
                    "
                    class="text-none ma-2"
                    exact
                    rounded="pill"
                    size="large"
                  >
                    Learn More</v-btn
                  >
                </SimpleRevealCard>
              </v-col>
            </v-row>
          </v-item>
        </v-item-group>
      </template>
    </v-container>
  </v-sheet>
</template>

<script setup>
import { mdiArrowRight } from '@mdi/js'

defineProps({
  items: {
    required: true,
    type: Array
  },
  learnHref: {
    default: undefined,
    type: [Function, String]
  },
  scheduleHref: {
    default: undefined,
    type: [Function, String]
  },
  value: {
    required: true,
    type: Object
  }
})
</script>
